/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type TimeTrackingApproval = typeof TimeTrackingApproval[keyof typeof TimeTrackingApproval];


export const TimeTrackingApproval = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Invalid: 'Invalid',
} as const;
